// extracted by mini-css-extract-plugin
export default {"controls":"controls_controls__l4T5L","btn":"controls_btn__84ppd","likeBtn":"controls_likeBtn__r-hqJ","likeBtnRed":"controls_likeBtnRed__MtPh5"};